import React from "react";

import "../Css/Slide1.css";
import { Navbar } from "./Nav";

export const FirstSlide = () => {
  return (
    <>
      <div className="container-fluid background">
        <div className="row">
          <Navbar />
          <div className="col-md-3"></div>
          <div className="col-md-6">
            <div className="centerlogo">
              <img
                src={process.env.PUBLIC_URL + "assets/images/logo.png"}
                width="75%"
                alt="logo"
              />
            </div>
            <div style={{ marginTop: "-260px" }}>
              <h1 className="firsth1">Web Development School</h1>
              <p className="firstp">
                It’s is never too late to learn to code, if you want to start.
                Just choose your favorite programming language and start
                learning here.
              </p>
            </div>
          </div>
          <div className="col-md-3"></div>
        </div>
      </div>
      {/*                                                 Second Slide                                   */}
      <div className="container-fluid Secondbg">
        <div className="row">
          <div className="col-md-3"></div>
          <div className="col-md-6">
            <div className="mt-4">
              <h1 className="secondh1">Become a Developer</h1>
            </div>
            <div>
              <p className="secondp">
                WDSchool is a unique e-learning website, offers a tutorial of
                different popular programming languages with examples. The code
                on this popular tutorial website is tested and executed.
              </p>
            </div>
          </div>
          <div className="col-md-3"></div>
        </div>
      </div>
      <div className="container-fluid thirdSlidbg">
        <div className="row">
          <div className="col-md-4 mt-5">
            <div className="count">
              <h1 className="count_h1">01</h1>
            </div>
            <div>
              <div className="count_div1">
                <h1>Design</h1>
              </div>
              <p className="count_p1">
                “A successful website does three things: It attracts the right
                kinds of visitors. Guides them to the main services or product
                you offer. Collect Contact details for future ongoing relation.”
              </p>
            </div>
          </div>
          <div className="col-md-4 mt-5">
            <div className="count">
              <h1 className="count_h1">02</h1>
            </div>
            <div>
              <div className="count_div2">
                <h1>Learning</h1>
              </div>
              <p className="count_p2">
                “Any fool can write code that a computer can understand. Good
                programmers write code that humans can understand.”
              </p>
            </div>
          </div>
          <div className="col-md-4 mt-5">
            <div className="count">
              <h1 className="count_h1">03</h1>
            </div>
            <div>
              <div className="count_div3">
                <h1>Grow</h1>
              </div>
              <p className="count_p3">
                “We will grow your Skills by Teaching and Supporting you and
                expanding the Growth of your Carrer and helping you manage your
                business growth.”
              </p>
            </div>
          </div>
        </div>
      </div>

      {/*                                                     Third Slide                                */}

      <div
        class="container-fluid"
        style={{
          backgroundColor: "black",
          paddingBottom: "20px",
          height: "max-content",
        }}
      >
        <div class="row">
          <div class="col-md-2"></div>
          <div
            class="col-md-8"
            style={{
              position: "relative",
              zIndex: "1",
              marginTop: "-130px",

              paddingBottom: "25px",
            }}
          >
            <div>
              <img
                src={process.env.PUBLIC_URL + "assets/images/device.png"}
                width="100%"
                class="img-fluid"
                alt="logo"
              />
            </div>
          </div>
          <div class="col-md-2"></div>
        </div>
      </div>

      {/*                                                           Fourth Slide                                       */}

      <div class="container-fluid fourth_Slide">
        <div class="row">
          <div class="col-md-3"></div>
          <div class="col-md-6 mt-5">
            <div class="mt-5">
              <h1 className="count_h1">
                <strong> Learn Coding and Programming </strong>
              </h1>
              <hr />
            </div>
            <div>
              <p style={{ color: "white" }}>
                <strong>
                  It’s is never too late to learn to code, if you want to start.
                  Just choose your favorite programming language and start
                  learning here. You can start learning at your home with small
                  chunks of code. In this tutorial website, you can start with
                  any programming language, we have written the tutorial for you
                  in simple language with easy code examples.
                </strong>
              </p>
              <hr />
            </div>
          </div>

          <div class="col-md-3"></div>
        </div>
      </div>
    </>
  );
};
